<div *ngIf="validationError">
  <p class="alert alert-danger">{{ validationError }}</p>
</div>
<div class="mct-flex mct-col mct-gap-20" *ngIf="value">
  <div>
    <label>
      <input type="checkbox" [(ngModel)]="value.FormPaymentOptions.AllowBillMeOption" />
      {{ 'forms.form-builder.form-settings.allow-billme' | translate | titlecase }}
    </label>
  </div>
  <div class="ml-67 mct-flex mct-row mct-justify-start mct-items-center mct-gap-27" *ngIf="value.FormPaymentOptions.AllowBillMeOption">
    <label>{{ 'common.text' | translate | titlecase }}</label>
    <input type="text" class="form-control" [(ngModel)]="value.FormPaymentOptions.AllowBillMeOptionText" />
  </div>
  <div class="ml-67" *ngIf="value.FormPaymentOptions.AllowBillMeOption">
    <label>
      <input type="checkbox" [(ngModel)]="value.FormPaymentOptions.PreventMembershipOnBillMe" />
      {{ 'forms.form-builder.form-settings.prevent-member-on-bill-me' | translate | titlecase }}
    </label>
  </div>

  <div>
    <label>
      <input type="checkbox" [(ngModel)]="value.FormPaymentOptions.AllowCreditCardOption" />
      {{ 'forms.form-builder.form-settings.allow-credit-card' | translate | titlecase }}
    </label>
  </div>
  <div class="ml-67 mct-flex mct-row mct-justify-start mct-items-center mct-gap-27" *ngIf="value.FormPaymentOptions.AllowCreditCardOption">
    <label>{{ 'common.text' | translate | titlecase }}</label>
    <input type="text" class="form-control" [(ngModel)]="value.FormPaymentOptions.AllowCreditCardOptionText" />
  </div>

  <div>
    <label>
      <input type="checkbox" [(ngModel)]="value.FormPaymentOptions.AllowArb" (ngModelChange)="allowArbChanged($event)" />
      {{ 'forms.form-builder.form-settings.allow-arb' | translate }}
    </label>
  </div>
  <div class="ml-67 mct-flex mct-row mct-justify-start mct-items-center mct-gap-27" *ngIf="value.FormPaymentOptions.AllowArb">
    <label>{{ 'common.text' | translate | titlecase }}</label>
    <input type="text" class="form-control" [(ngModel)]="value.FormPaymentOptions.AllowArbOptionText" />
  </div>
  <div class="ml-67" *ngIf="value.FormPaymentOptions.AllowArb">
    <label>
      <input type="checkbox" [(ngModel)]="value.FormPaymentOptions.CreateInvoiceChargeOnSubmit" />
      {{ 'forms.form-builder.form-settings.invoice-and-charge' | translate | ucfirst }}
    </label>
  </div>
  <div class="ml-67" *ngIf="value.FormPaymentOptions.AllowArb">
    <label>
      <input type="checkbox" [(ngModel)]="value.FormPaymentOptions.RequireArb" />
      {{ 'forms.form-builder.form-settings.require-arb' | translate }}
    </label>
  </div>

  <div>
    <label>{{ 'forms.form-builder.form-settings.activity-type' | translate | titlecase }}</label>
    <select class="form-control" [(ngModel)]="value.ActivityTypeId">
      <option>{{ 'common.select' | translate | titlecase }}</option>
      <option *ngFor="let item of activityTypes" [value]="item.ActivityTypeID">{{ item.ActivityType }}</option>
    </select>
  </div>

  <div>
    <label>{{ 'forms.form-builder.form-settings.membership.membership' | translate | titlecase }}</label>
    <div class="ml-15 mct-flex mct-row mct-gap-27">
      <label>
        <input type="radio" [(ngModel)]="value.FormOrgIndEnum" [value]="profileOrgInd.Individual" />
        {{ 'forms.form-builder.form-settings.membership.individual' | translate | titlecase }}
      </label>
      <label>
        <input type="radio" [(ngModel)]="value.FormOrgIndEnum" [value]="profileOrgInd.Organization" />
        {{ 'forms.form-builder.form-settings.membership.organization' | translate | titlecase }}
      </label>
    </div>
  </div>

  <div>
    <label>{{ 'forms.form-builder.form-settings.aff-codes-to-apply-label' | translate | ucfirst }}</label>
    <wl-affcode-chip-selector [(ngModel)]="value.AffCodesToApply"></wl-affcode-chip-selector>
  </div>

  <div>
    <label>{{ 'forms.form-builder.form-settings.email-settings' | translate | titlecase }}</label>
    <div class="mb-12">
      <button
        app-add-button
        class="atlas-btn atlas-btn-primary"
        [label]="'forms.form-builder.form-settings.new-email-notifications' | translate | titlecase"
        (click)="newNotificationEmail()"
      ></button>
    </div>
    <div *ngFor="let testvas of value.CommunicationOptions.NotificationEmails; let i = index" class="ml-12 mr-12 mb-12">
      <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-12">
        <label class="mct-flex-none">{{ 'common.personal-information.email' | translate | titlecase }}</label>
        <input type="email" required class="form-control mct-flex-1-1-auto" [(ngModel)]="testvas.Email" />
        <button
          pButton
          type="button"
          class="atlas-btn atlas-btn-danger mct-flex-none"
          icon="pi pi-trash"
          [label]="'common.remove' | translate | titlecase"
          (click)="removeNotificationEmail(i)"
        ></button>
      </div>
    </div>
  </div>

  <div>
    <label>{{ 'forms.form-builder.form-settings.association-name-override' | translate | titlecase }}</label>
    <input type="text" class="form-control" [(ngModel)]="value.CommunicationOptions.AssociationNameOverride" />
  </div>

  <div>
    <label>{{ 'forms.form-builder.form-settings.confirmation-email-message-text' | translate | titlecase }}</label>
    <div *ngIf="showEditor">
      <wl-wysiwyg-editor
        [showHtmlTemplates]="false"
        [disableImageSelector]="true"
        [emailContent]="true"
        [(ngModel)]="value.CommunicationOptions.ConfirmationEmailMessage"
      ></wl-wysiwyg-editor>
    </div>
  </div>
</div>
